// extracted by mini-css-extract-plugin
export default {"MobileLocations":"locations_MobileLocations__gGEaG","Locations":"locations_Locations__ys5yp","Location":"locations_Location__0pTY8"};